module.exports = __webpack_public_path__ + "img/globe.75f4f85a.webp";